import React from 'react';

function Hero() {
  return (
    <section id="home" className="bg-gradient-to-r from-blue-900 to-orange-500 text-white py-20 text-center">
      <div className="container mx-auto">
        <h1 className="text-4xl font-bold mb-4">Empower Your Business with AI-Driven Solutions</h1>
        <p className="text-lg mb-6">Serve Customers with Care and Innovation.</p>
        <a href="#contact" className="bg-white text-blue-900 px-6 py-3 rounded-full hover:bg-gray-200 transition">
          Contact Us
        </a>
      </div>
    </section>
  );
}

export default Hero;